import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { INPUT_TYPES } from '@CommonConstants';

import { ReactComponent as CheckBoxOffSVG } from '@Assets/Svgs/selection_checkbox_off.svg';
import { ReactComponent as CheckBoxOnSVG } from '@Assets/Svgs/selection_checkbox_on.svg';
import TextCSS from '../Text/Styles';

const Checkbox = ({ id, isChecked, label, Icon, fill, onChange }) => {
  return (
    <CheckboxContainer>
      <CheckBoxWrapper isChecked={isChecked} htmlFor={id}>
        <HiddenCheckbox id={id} type={INPUT_TYPES.CHECKBOX} onChange={onChange} checked={isChecked} />
        {isChecked ? <CheckedIcon /> : <UnCheckedIcon />}
      </CheckBoxWrapper>

      {Icon && (
        <CustomIconWrapper>
          <Icon width={16} height={16} fill={fill} />
        </CustomIconWrapper>
      )}

      {label && <Label htmlFor={id}>{label}</Label>}
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.elementType,
  fill: PropTypes.string,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  Icon: undefined,
  fill: undefined,
  onChange: () => {},
};

const FlexAlignCenterCSS = css`
  display: flex;
  align-items: center;
`;

const CheckboxContainer = styled.div`
  ${FlexAlignCenterCSS}
`;

const CheckBoxWrapper = styled.label`
  ${FlexAlignCenterCSS}
  justify-content: center;

  width: 16px;
  height: 16px;

  cursor: pointer;
  margin-right: 8px;
`;

const HiddenCheckbox = styled.input`
  width: 1px;
  height: 1px;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;

  opacity: 0;
`;

const IconCSS = css`
  width: 100%;
  height: 100%;
`;

const CheckedIcon = styled(CheckBoxOnSVG)`
  ${IconCSS}
`;

const UnCheckedIcon = styled(CheckBoxOffSVG)`
  ${IconCSS}
`;

const CustomIconWrapper = styled.div`
  ${FlexAlignCenterCSS}
  justify-content: center;

  width: 16px;
  height: 16px;
  margin-right: 8px;

  cursor: pointer;
`;

const Label = styled.label`
  ${TextCSS.FootnoteM}

  display: inline-block;
  cursor: pointer;
`;

export default Checkbox;
